<template>
    <ContentLayout>
        <div class="space-y-6">
            <header>
                <Breadcrumb :items="breadcrumbs" />
                <Heading :level="1" title="Typography" subtitle="Preview of typography components." />
            </header>

            <Card>
                <CardContent class="space-y-4 rounded">
                    <section class="space-y-4 pt-6">
                        <Heading :level="2" title="Visuals" />

                        <section class="space-y-4">
                            <div>
                                <Heading
                                    :level="3"
                                    title="Headings"
                                    subtitle="The Heading component provides a flexible way to display titles and subtitles with semantic heading levels (h1-h6)."
                                />
                            </div>

                            <div>
                                <Heading title="Heading Level 1" subtitle="Subtitle for H1" :level="1" />
                            </div>
                            <div>
                                <Heading title="Heading Level 2" subtitle="Subtitle for H2" :level="2" />
                            </div>
                            <div>
                                <Heading title="Heading Level 3" subtitle="Subtitle for H3" :level="3" />
                            </div>
                            <div>
                                <Heading title="Heading Level 4" subtitle="Subtitle for H4" :level="4" />
                            </div>
                            <div>
                                <Heading title="Heading Level 5" subtitle="Subtitle for H5" :level="5" />
                            </div>
                            <div>
                                <Heading title="Heading Level 6" subtitle="Subtitle for H6" :level="6" />
                            </div>
                        </section>
                    </section>

                    <section class="space-y-4 pt-6">
                        <div>
                            <Heading
                                :level="2"
                                title="Code"
                                subtitle="Heading Component"
                                subtitle-class="font-mono text-sm uppercase text-slate-700"
                            />
                        </div>

                        <section class="space-y-4">
                            <pre
                                class="h-96 overflow-x-auto rounded bg-gray-900 p-4 text-green-200"
                            ><code>{{ HeadingCode }}</code></pre>
                        </section>
                    </section>
                </CardContent>
            </Card>
        </div>
    </ContentLayout>
</template>

<script setup>
import { useRouter } from 'vue-router'
import Breadcrumb from '@/partials/navigation/Breadcrumb.vue'
import { ContentLayout } from '@/components/ui/layouts'
import { Heading } from '@/components/ui/typography'
import { Card, CardContent } from '@/components/ui/card'
import HeadingCode from '@/components/ui/typography/Heading.vue?raw'

const router = useRouter()

const breadcrumbs = [
    { label: 'Playground', onClick: () => router.push({ name: 'playground' }) },
    { label: 'Typography' },
]
</script>
